export enum DisplayState {
    FORM = 'contactAgentForm',
    ABAD_CONTENT = 'abadContent',
    SUCCESS = 'submitSuccess',
}
